import UsersTab from "@features/security/components/UsersTab";
import { hasPermission, resolvePermissions } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Users } from "lucide-react";

/**
 * `/admin` is the Utilisateurs tab, but also the module root URL reached from the
 * sidebar. A profile holding only `security.*` permissions without
 * `security.users.view` must not bounce to /unauthorized here: redirect to the
 * FIRST tab it may open, in staticData.order, instead (PLAN Validation Tâche 6.2,
 * audit 17 §1.1, wireframe W9). Last resort (a security.* grant exists but no tab
 * is readable) → /unauthorized, per W9.
 */
const ACCESSIBLE_TAB_ORDER = [
  { permission: PERMISSIONS.SECURITY.USERS.VIEW, to: "/admin/" },
  { permission: PERMISSIONS.SECURITY.PROFILES.VIEW, to: "/admin/profiles/" },
  { permission: PERMISSIONS.SECURITY.PERMISSIONS.VIEW, to: "/admin/permissions/" },
  { permission: PERMISSIONS.SECURITY.PERMISSIONS.VIEW, to: "/admin/reference-data/" },
] as const;

export const Route = createFileRoute("/_app/admin/")({
  loader: async (ctx) => {
    const resolved = await resolvePermissions(ctx.parentMatchPromise);
    const firstAccessible = ACCESSIBLE_TAB_ORDER.find((tab) =>
      hasPermission(resolved.permissions, resolved.hasWildcard, resolved.context, tab.permission),
    );
    if (!firstAccessible) throw redirect({ to: "/unauthorized" });
    if (firstAccessible.to !== "/admin/") throw redirect({ to: firstAccessible.to });
  },
  staticData: {
    title: "Utilisateurs",
    icon: Users,
    tab_icon: Users,
    permission: PERMISSIONS.SECURITY.USERS.VIEW,
    module: "security",
    section: "Administration",
    order: 10,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des utilisateurs",
  },
  component: UsersTab,
});
